//third party popup
var modal = $('#modal__third-party-product');
var btn = $("#tpt_modal_open");
var span = $(".modal-close");

var herb_close = $(".herb-modal-close"); 
var herb_modal = $(".herb-popup");
var herb_btn_class = $(".learn_more_glossary");


$(document).ready(function () {


       $('.show_hide').on("click", function () {
          event.preventDefault();
          var txt = $(".content").hasClass('show_content') ? 'Read More' : 'Read Less';
          $(".show_hide").text(txt);
          $('.content').toggleClass('show_content');
         });

        $('.read_more').on("click", function () {
          event.preventDefault();
          var txt = $(".about-the-formula__item").hasClass('accordion-card--reveal') ? 'Read More' : 'Read Less';
          $(".read_more").text(txt);
          
          $(this).parents(".about-the-formula__item").toggleClass('accordion-card--reveal');
         });


          $('.read_more_abtf').on("click", function () {
          event.preventDefault();
          var txt = $(".about-the-formula__headeritem").hasClass('accordion-card--reveal') ? 'Read More' : 'Read Less';
          $(".read_more_abtf").text(txt);
          
          $(this).parents(".about-the-formula__headeritem").toggleClass('accordion-card--reveal');
         });


      $('ul.tab-learn-more').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('is-active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
          $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function(e){
          active.removeClass('is-active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('is-active');
          content.show();
          return false;
        });
    });

      // Third Party modal
      btn.on('click', function() {
          modal.show();
      });
      span.on('click', function() {
          modal.fadeOut();
      });


  
      herb_btn_class.on('click', function(e) {
          e.preventDefault();
          $('.herb-popup[data-herb*='+ this.id + ']').show();
          if ($('.herb-popup[data-herb*='+ this.id + '] iframe').length) {
              window.addEventListener('message', e => {
                if (e.data.scrollHeight && e.data.scrollHeight !== e.data.clientHeight) {
                  $('.herb-popup[data-herb*='+ this.id + '] iframe').css('height', e.data.scrollHeight + 'px');
                }
              })
            }        
      });



      herb_close.on('click', function() {
          (herb_modal).fadeOut();
      }); 

    // Load more Button on the Learn more Product page
    $(".load-more-ingredients").hide();
    $(".load_more_button").on("click", function () {
        event.preventDefault();
        var txt = $(".load-more-ingredients").is(':visible') ? 'Load More' : 'Load Less';
        $(".load_more_button").text(txt);
        $('.load-more-ingredients').slideToggle(200);
    });



    $('.zoom').magnify();


  
// function to add commas thousand separator to number. Wrap num in span with class "num_w_com"
  $(".num_w_com").each(function(){ 
    var amount = parseFloat($(this).html()); // Convert string into float number
    var newamount = amount.toLocaleString('en-US'); // add comma
    $(this).html(newamount); // replace old number with new number
  });


// function to target button with class exchange__button_target and data-btn-target that matches data-reward-id attritube on Loyalty Lion. 
//exchange__button_target

  $('.exchange__button_target').on("click", function() {
    var id = $(this).data('btn-target');
    var section = $('.lion-reward-item[data-reward-id=' + id + ']');
    $('html, body').animate({
      scrollTop: $(section).offset().top
    }, 'slow');
  });
  
});



  // PDP Mobile Image Slider
  // ================================================
  // var pdpImageSlider = new Swiper(".mobile-image-slideshow", {
  //   spaceBetween: 30,
  //   effect: 'fade',
  //   pagination: {
  //     el: '#swiper-image-slideshow-pagination',
  //     type: "bullets",
  //     clickable: true,
  //   },
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  // });
  function showProductImage(idx) {
    $('.slideshow-thumbs').find('.selected').removeClass('selected');
    $('.thumb-slide:eq(' + idx + ')').addClass('selected');
    $('.slideshow-originals').find('.selected').removeClass('selected').removeClass('zoom');
    $(".original-slide:eq(" + idx + ")").addClass('selected').addClass('zoom');
    $('.zoom').magnify();
  }
  $('.thumb-slide').on('click', function () {
    let idx = $(this).data('index');
    showProductImage(idx);
     

});

      // When the user clicks anywhere outside of the modal, close Third Party Testing Modal
      $('body').bind('click', function(e){
          if($(e.target).hasClass("modal-inner")){
              modal.fadeOut();
          }
      }); 

     // Close Herb Modal
      $('body').bind('click', function(e){
          if($(e.target).hasClass("herb-modal-inner")){
              (herb_modal).fadeOut();
          }
      }); 


//Open Modal Search Lot
  const toggleModal = document.querySelector('#searchBtnLot');
  const modalContainer = document.querySelector('.search-lot');
  const closeSearchLotModal = document.querySelector('.btnCloseLot');
  const overlaySearchLot = document.querySelector('.overlaySearchlot');
  toggleModal?.addEventListener('click', () => {
    modalContainer.classList.toggle('open-element');
  })
  closeSearchLotModal?.addEventListener('click', () => {
    modalContainer.classList.remove('open-element');
  })
  overlaySearchLot?.addEventListener('click', () => {
    modalContainer.classList.remove('open-element');
  })

$(document).ready(function () {
  // PDP How to Use Sliders
  // ================================================
  var pdpHowToUseImageSlider = new Swiper("#how-to-use-image-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: true,
    pagination: {
      el: "#swiper-how-to-use-pagination",
      type: "bullets",
      clickable: true
    }
  });
  var pdpHowToUseTextSlider = new Swiper("#how-to-use-text-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
  });
  pdpHowToUseImageSlider.controller.control = pdpHowToUseTextSlider;
  pdpHowToUseTextSlider.controller.control = pdpHowToUseImageSlider;
});